import clsx from 'clsx';

export function DepartmentTabs({ value, onChange, canCafeteria, canToys }) {
  const tabs = [
    { key: 'cafeteria', label: 'الكافتيريا', icon: '🍕', enabled: canCafeteria },
    { key: 'toys', label: 'محل الألعاب', icon: '🧸', enabled: canToys }
  ];
  return (
    <div className="inline-flex bg-white border border-line rounded-[12px] p-1 shadow-card">
      {tabs.map((t) => (
        <button
          key={t.key}
          type="button"
          disabled={!t.enabled}
          onClick={() => t.enabled && onChange(t.key)}
          className={clsx(
            'px-4 py-2 rounded-[10px] text-[13.5px] font-bold transition-colors',
            value === t.key ? 'bg-orange text-white shadow-orange-glow' : 'text-ink-2',
            !t.enabled && 'opacity-40 cursor-not-allowed'
          )}
        >
          <span className="me-1.5">{t.icon}</span>{t.label}
        </button>
      ))}
    </div>
  );
}
